<template>
    <section>
        <div
            class="banner"
            v-if="bannerImage"
            :style="{backgroundImage: 'url('+ bannerImage +')',height:bannerHeight}"
        ></div>
    </section>
</template>

<script>
export default {
    name: "banner",
    data() {
        return {
            bannerImage: pageDatas.bannerDatas.bannerImage,
            bannerHeight: pageDatas.bannerDatas.bannerHeight
            //  bannerImage:'pageDatas.bannerDatas.bannerImage',
            // bannerHeight:'pageDatas.bannerDatas.bannerHeight'
        };
    }
};
</script>

<style >
.banner {
    text-align: center;
    background: top center no-repeat;
}
</style>
